import { object, optional, fallback, string } from 'valibot'

export const publicSearchSchema = object({
  redirect: fallback(optional(string()), '')
})
